export default "__VITE_ASSET__CSt7dc8v__"